
/* injects from baggage-loader */

export const PlayerTypes = [
    require('_images/level-bar/cliente.png'),
    require('_images/level-bar/garcom.png'),
    require('_images/level-bar/chef.png')
];

export const Lvls = [
    require('_images/level-bar/lvl-1.png'),
    require('_images/level-bar/lvl-2.png'),
    require('_images/level-bar/lvl-3.png'),
    require('_images/level-bar/lvl-4.png'),
    require('_images/level-bar/lvl-5.png'),
    require('_images/level-bar/lvl-6.png')
];


// WEBPACK FOOTER //
// ./src/app/components/ui/level-bar/level-bar.const.js